import styled from "styled-components";
import {Assets} from "../../../../../../themes/assets";

export const InputDefaultBox = styled.input<{disabled: boolean}>`
  appearance: none;
  position: relative;
  height: 1.8rem;
  width: 1.8rem;
  cursor: ${props => props.disabled ? "auto" : "pointer"};

  display: inline-flex;
  align-items: center;
  justify-content: center;

  background-color: ${props => props.theme.colors.backgroundMiddleDark};
  border: 1px solid ${props => props.theme.colors.text};
  border-radius: 4px;

  &:checked {
    background-color: ${props => props.theme.colors.textLight};

    &:after {
      content: '';
      display: block;
      background-image: url(${Assets.images.selected_filter_sign_svg.toString()});
      background-repeat: no-repeat;
      background-position: center center;
      height: 100%;
      width: 100%;
      font-size: 13px;
      line-height: 1.8rem;
      color:  ${props => props.theme.colors.backgroundMiddleDark};
      font-weight: bold;
    }
  }
`;
